import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/hand/add/produce-crafts`,
    name: 'CRAFT_MANAGE_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
